import { useEffect, useState } from "react";
import { History, RotateCcw, ChevronDown, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import api from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
const short = (u) => (u ? u.replace("https://api.spoki.com/wh/ap/", "…/").slice(0, 26) : "nessuna");

export function SettingsHistory({ onRestored, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.waSettingsHistory().then(setRows).catch(() => {}); }, [refreshKey]);
  const restore = async (h) => {
    if (!window.confirm(`Ripristinare le impostazioni WhatsApp alla versione del ${fmt(h.created_at)}? La versione attuale viene salvata nello storico.`)) return;
    setBusy(h.id);
    try {
      await api.waSettingsRestore(h.id);
      toast.success("Impostazioni ripristinate");
      setRows(await api.waSettingsHistory());
      onRestored?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Ripristino non riuscito"); } finally { setBusy(null); }
  };
  return (
    <Card className="bg-card border-border" data-testid="whatsapp-settings-history">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 p-4 text-left text-sm font-semibold" data-testid="whatsapp-settings-history-toggle">
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        <History className="h-4 w-4" /> Storico impostazioni WhatsApp
        <span className="ml-auto text-xs text-muted-foreground font-normal">{rows.length} versioni</span>
      </button>
      {open && (rows.length === 0 ? (
        <p className="px-4 pb-4 text-xs text-muted-foreground" data-testid="whatsapp-settings-history-empty">Nessuna versione precedente: lo storico si popola a ogni salvataggio.</p>
      ) : (
        <ul className="divide-y divide-border border-t border-border">
          {rows.map((h) => (
            <li key={h.id} className="flex items-center gap-3 px-4 py-2 text-xs" data-testid={`wa-history-${h.id}`}>
              <div className="flex-1 min-w-0">
                <p className="font-mono-code">{fmt(h.created_at)}{h.actor && <span className="text-muted-foreground"> · {h.actor}</span>}</p>
                <p className="text-muted-foreground truncate">Automazione {short(h.summary.automation_url)}{h.summary.has_automation_secret ? " (con secret)" : ""} · Silenzio {h.summary.quiet} · Sconti classifica {h.summary.rank_discount_enabled ? "ON" : "OFF"}</p>
              </div>
              <Button size="sm" variant="secondary" className="h-7 text-xs gap-1 shrink-0" disabled={busy === h.id} onClick={() => restore(h)} data-testid={`wa-history-restore-${h.id}`}>
                <RotateCcw className="h-3 w-3" /> Ripristina
              </Button>
            </li>
          ))}
        </ul>
      ))}
    </Card>
  );
}
